export default "__VITE_ASSET__BTtBmBZh__"